<template>
  <a
    v-if="link.external"
    :href="link.route"
    class="nav-link"
    :class="{
      active: link.route.name === $route.name,
    }"
  >
    <span>
      <span class="name">{{ link.name }}</span>
      <span v-if="link.new" class="new">NEW!</span>
    </span>
  </a>
  <router-link
    v-else
    :to="link.route"
    class="nav-link"
    :class="{
      active: link.route.name === $route.name,
    }"
  >
    <span>
      <span class="name">{{ link.name }}</span>
      <span v-if="link.new" class="new">NEW!</span>
    </span>
  </router-link>
</template>

<script>
export default {
  props: {
    link: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.nav-link {
  margin: 0 2rem;
  height: 5.5rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  span {
    font-family: $font-display;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 110%;
    color: #fff;
    @include desktop-down {
      font-size: 1.9rem;
    }
    .name {
      opacity: 0.6;
    }
    .new {
      background-color: #f9a821;
      border-radius: 2px;
      color: #141417;
      font-size: 1.3rem;
      margin-left: 0.5rem;
      padding: 0.3rem 0.8rem;
    }
  }
  border-bottom: 2px solid transparent;
  @include desktop-down {
    border: none;
  }
}
.nav-link:hover,
.active {
  border-bottom: 2px solid #fff;
  transition: border-color 0.2s linear;
  .name {
    opacity: 1 !important;
  }
  @include desktop-down {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavLink.vue